export default {
  setReady(state, done) {
    state.ready = done;
  },
  importDays(state, days) {
    state.days = days;
  },
};



// WEBPACK FOOTER //
// ./assets/js/timetable/store/mutations.js